export default __webpack_public_path__ + "static/media/digitalLiteracy.b0c96f85.png";